(function() {
    'use strict';

    angular
        .module('dialysisApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('rpt-metadata', {
            parent: 'entity',
            url: '/rpt-metadata',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'RptMetadata'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rpt-metadata/rpt-metadata.html',
                    controller: 'RptMetadataController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
            }
        })
        .state('rpt-metadata-detail', {
            parent: 'entity',
            url: '/rpt-metadata/{id}',
            data: {
                authorities: ['ROLE_ADMIN'],
                pageTitle: 'RptMetadata'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/rpt-metadata/rpt-metadata-detail.html',
                    controller: 'RptMetadataDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                entity: ['$stateParams', 'RptMetadata', function($stateParams, RptMetadata) {
                    return RptMetadata.get({id : $stateParams.id}).$promise;
                }],
                previousState: ["$state", function ($state) {
                    var currentStateData = {
                        name: $state.current.name || 'rpt-metadata',
                        params: $state.params,
                        url: $state.href($state.current.name, $state.params)
                    };
                    return currentStateData;
                }]
            }
        })
        .state('rpt-metadata-detail.edit', {
            parent: 'rpt-metadata-detail',
            url: '/detail/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-metadata/rpt-metadata-dialog.html',
                    controller: 'RptMetadataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RptMetadata', function(RptMetadata) {
                            return RptMetadata.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('^', {}, { reload: false });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rpt-metadata.new', {
            parent: 'rpt-metadata',
            url: '/new',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-metadata/rpt-metadata-dialog.html',
                    controller: 'RptMetadataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                intCode: null,
                                description: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('rpt-metadata', null, { reload: 'rpt-metadata' });
                }, function() {
                    $state.go('rpt-metadata');
                });
            }]
        })
        .state('rpt-metadata.edit', {
            parent: 'rpt-metadata',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-metadata/rpt-metadata-dialog.html',
                    controller: 'RptMetadataDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RptMetadata', function(RptMetadata) {
                            return RptMetadata.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-metadata', null, { reload: 'rpt-metadata' });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('rpt-metadata.delete', {
            parent: 'rpt-metadata',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_ADMIN']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/rpt-metadata/rpt-metadata-delete-dialog.html',
                    controller: 'RptMetadataDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RptMetadata', function(RptMetadata) {
                            return RptMetadata.get({id : $stateParams.id}).$promise;
                        }]
                    }
                }).result.then(function() {
                    $state.go('rpt-metadata', null, { reload: 'rpt-metadata' });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
